import {AvatarDialogue} from './AvatarDialogue';
export default AvatarDialogue;
